<template>
  <div>
    <el-dialog :visible.sync="visible"
               custom-class="whaty-dialog-form"
               :width="formDialogWidth"
               @open="handleDialogOpen"
               @close="handleDialogClose"
               :closeOnClickModal="false"
               :modal-append-to-body="false">
      <div slot="title" class="popup-head">
        <span class="title">{{ formConfig.title || '&nbsp;' }}</span>
      </div>
        <div>
          <common-form
            ref="myForm"
            :type="'dialog'"
            :formConfig="formConfig"
            :showHeader="false"
            :showFooter="false"
            @submit-start="submitStart"
            @submit-success="submitSuccess"
            @submit-error="submitError"
            @change-router="handleChangeRouter"
          ></common-form>
        </div>
      <div slot="footer" class="popup-foot group" :style="{'text-align': (formConfig.footerAlign ? formConfig.footerAlign : 'right')}">
        <whaty-button button-class="btn btn-anti-default" @click="handleCancel">取消</whaty-button>
        <whaty-button :disabled="submitButtonDisabled" button-class="btn btn-solid-primary" @click="handleSubmit">提交</whaty-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import CommonForm from './common-form'
  import WhatyButton from '../whaty-button'
  // import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event'

  export default {
    name: 'dialog-form',
    components: {WhatyButton, CommonForm},
    props: {
      formConfig: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        visible: false,
        submitButtonDisabled: false
      }
    },
    computed: {
      formDialogWidth: function () {
        let editColumns = []
        if (this.formConfig && this.formConfig.fields && this.formConfig.fields.length > 0) {
          for (let i = 0; i < this.formConfig.fields.length; i++) {
            let field = this.formConfig.fields[i]
            if (!field.id) {
              continue
            }
            // 收集允许编辑的字段
            if (field.canEdit) {
              editColumns.push(field)
            }
          }
        }
        // 根据可编辑字段的个数,设置显示样式(单列/两列)
        return editColumns.length > 4 ? '880px' : '480px'
      }
    },
    methods: {
      show() {
        this.visible = true
        this.resetForm()
      },
      hide() {
        this.visible = false
      },
      // 重置form表单
      resetForm() {
        if (this.$refs.myForm) {
          this.$refs.myForm.resetForm()
        }
      },
      handleDialogOpen() {
        this.$nextTick(() => {
          this.$el.querySelector('.el-dialog__body').addEventListener('scroll', this.$refs.myForm.closeFormDrop)
        })
        this.enableSubmitButton()
      },
      // form dialog关闭时被触发
      handleDialogClose() {
        this.$el.querySelector('.el-dialog__body').removeEventListener('scroll', this.$refs.myForm.closeFormDrop)
        this.resetForm()
        this.$emit('close')
      },
      submitStart() {
        this.disableSubmitButton()
        this.$emit('submit-start')
      },
      submitSuccess() {
        this.$emit('submit-success')
        setTimeout(() => {
          this.enableSubmitButton()
        }, 300)
      },
      submitError() {
        this.enableSubmitButton()
        this.$emit('submit-error')
      },
      handleChangeRouter(router) {
        this.enableSubmitButton()
        this.$emit('change-router', router)
      },
      handleSubmit() {
        this.$refs.myForm.handleSubmit()
      },
      handleCancel() {
        this.hide()
      },
      disableSubmitButton() {
        this.submitButtonDisabled = true
      },
      enableSubmitButton() {
        this.submitButtonDisabled = false
      }
    },
    mounted() {
      // TODO: 增加window高度监听事件，改变dialog form高度
    },
    beforeDestroy() {
      // TODO: 去掉window高度变化的监听事件
    }
  }
</script>
<style lang="scss">

.whaty-dialog-form {
  border-radius: 6px;

  .el-dialog {
    border-radius: 6px;
  }

  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    overflow-y: auto;
    // 主要兼容修改的dialog
    max-height: 504px;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      cursor: pointer;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
      /*滚动条的背景颜色*/
    }

    &::-webkit-scrollbar-thumb {
      background-color: #DCDFE6;
      border-radius: 3px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  .el-dialog__headerbtn {
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    border: 1px solid transparent;
    line-height: 22px;
    border-radius: 4px;
    font-size: 18px;
  }

  .el-dialog__headerbtn:hover {
    color: inherit;
    background-color: #f3f5f7;
  }

  .el-dialog__headerbtn:hover .el-dialog__close {
    color: #666666;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #666666;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 0;
  }

  .form-table-wrap:after {
    display: none;
  }

  .popup-content {
    padding: 8px 0 10px 0;
  }

  .form-table-wrap {
    margin: 0;
    padding: 8px 12px 8px 12px;
    line-height: 1;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/grid/dialog-form.vue